import { Backdrop, Button, Card, ThemeToggle } from '@memorizecards/ui';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  erro: Error | null;
}

/**
 * Rede de segurança da árvore inteira.
 *
 * Sem isto, um erro num gráfico do painel de desempenho deixa a página em
 * branco e o aluno sem nenhuma pista do que fazer. Aqui pelo menos há um botão
 * para recarregar e um caminho de volta.
 */
export class LimiteDeErro extends Component<Props, State> {
  override state: State = { erro: null };

  static getDerivedStateFromError(erro: Error): State {
    return { erro };
  }

  override componentDidCatch(erro: Error, info: ErrorInfo): void {
    // Sem serviço de telemetria por enquanto; a consola do navegador é o que
    // existe para diagnosticar um relato de suporte.
    console.error('[MemorizeCards] erro na interface', erro, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.erro) return this.props.children;

    return (
      <div className="relative grid min-h-screen place-items-center px-4">
        <Backdrop />
        <div className="fixed right-4 top-4 z-50">
          <ThemeToggle size="sm" />
        </div>
        <Card padding="lg" className="relative z-[2] max-w-lg text-center">
          <h1 className="text-mc-h3">Algo quebrou nesta tela</h1>
          <p className="mt-3 text-mc-body text-mc-ink2">
            Já registramos o problema. Recarregar costuma resolver; se continuar,
            escreva para contato@memorizecards.com.br.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Button onClick={() => window.location.reload()}>Recarregar</Button>
            <Button
              variant="ghost"
              onClick={() => {
                window.location.href = '/baralhos';
              }}
            >
              Voltar ao início
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}
